var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom" }, [
      _c("div", { staticClass: "btm-panel" }, [
        _c("div", { staticClass: "intro" }, [
          _c("img", {
            staticClass: "logo",
            attrs: { src: "/static/image/logo_foot@2x.png" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "tag-panel" }, [
            _c("div", { staticClass: "tag" }, [
              _c("div", { staticClass: "item" }, [
                _vm._v("南京晨新医疗科技有限公司")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item a" }, [
                _vm._v(
                  "\n            地址：南京市鼓楼区清江南路18号鼓楼创新广场D栋18层\n          "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item a" }, [
                _vm._v("电话：400-1331-551")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "em" }, [
                _c("div", { staticClass: "item a ema" }, [
                  _vm._v("\n              邮箱：\n            ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ea" }, [
                  _c("div", { staticClass: "item a" }, [
                    _vm._v("商务合作 business@cnewmedical.com")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item a" }, [
                    _vm._v("简历投递 hr@cnewmedical.com")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "logo-foot" }, [
              _c("div", { staticClass: "logo-foot_c" }, [
                _c("img", {
                  staticClass: "t_image",
                  attrs: { src: "/static/image/img_gongzhonghao@2x.png" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "label" }, [
                  _vm._v("关注晨新医疗公众号")
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "copy" }, [
          _c("div", { staticClass: "value" }, [
            _vm._v(
              "\n        版权所有 © 2022 晨新医疗 cnewmedical 苏ICP备2023047460号-1\n      "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ab164b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ab164b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 